import { Experiment } from '@cian/experiments/ab';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { getTrackPromoBanner } from './tracking';
import { PikPromoBanner } from '../../components/PikPromoBanner';
import { PIK_LANDING_QS } from '../../constants/common';
import { AUD_MOBILE_INCREASE_RECS_DEPTH } from '../../constants/experiments';
import { getDeviceType } from '../../selectors/page';
import { selectPikPromoBanner } from '../../selectors/pikPromoBanner';
import { selectCurrentRegionId } from '../../selectors/regions';
import { IApplicationState } from '../../types/redux';
import { useApplicationContext } from '../ApplicationContext';

function selectParentRegion(state: IApplicationState) {
  return state.geoLocation.currentRegion.parentId;
}

export function PikPromoBannerContainer() {
  const { config } = useApplicationContext();
  const currentRegionId = useSelector(selectCurrentRegionId);
  const parentRegionId = useSelector(selectParentRegion);
  const pikPromoBanner = useSelector(selectPikPromoBanner);
  const regionId = parentRegionId || currentRegionId;
  const deviceType = useSelector(getDeviceType);
  const pikRegions = config.get<number[]>('PikPromoRegions') || [];

  if (!pikRegions.includes(regionId)) {
    return null;
  }

  return (
    <Experiment name={AUD_MOBILE_INCREASE_RECS_DEPTH} group="A" default>
      <PikPromoBanner
        onClick={getTrackPromoBanner({ label: 'pik', deviceType, queryString: PIK_LANDING_QS })}
        disclaimer={pikPromoBanner.disclaimer}
        hitUrl={pikPromoBanner.hitUrl}
      />
    </Experiment>
  );
}
